import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'es-419',
  months: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthsShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'],
  weekdays: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  weekdaysShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    'LL-D': 'MMMM [de] YYYY',
    'LL-Y': 'D [de] MMMM',
    LLL: 'D [de] MMMM [de] YYYY, HH:mm',
    'LLL-Y': 'D [de] MMMM, HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY, HH:mm',
    'LLLL-Y': 'dddd D [de] MMMM, HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D [de] MMMM [de] YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'a. m.', pm: 'p. m.', AM: 'a. m.', PM: 'p. m.' },
  past: {
    y: { one: 'hace %s a', other: 'hace %s a' },
    M: { one: 'hace %s m', other: 'hace %s m' },
    w: { one: 'hace %s sem.', other: 'hace %s sem.' },
    d: { one: 'hace %s día', other: 'hace %s días' },
    h: { one: 'hace %s h', other: 'hace %s h' },
    m: { one: 'hace %s min', other: 'hace %s min' },
    s: { one: 'hace %s s', other: 'hace %s s' },
  },
  future: {
    y: { one: 'dentro de %s a', other: 'dentro de %s a' },
    M: { one: 'dentro de %s m', other: 'dentro de %s m' },
    w: { one: 'dentro de %s sem.', other: 'dentro de %s sem.' },
    d: { one: 'dentro de %s día', other: 'dentro de %s días' },
    h: { one: 'dentro de %s h', other: 'dentro de %s h' },
    m: { one: 'dentro de %s min', other: 'dentro de %s min' },
    s: { one: 'dentro de %s s', other: 'dentro de %s s' },
  },
  pastLong: {
    y: { one: 'hace %s año', other: 'hace %s años' },
    M: { one: 'hace %s mes', other: 'hace %s meses' },
    w: { one: 'hace %s semana', other: 'hace %s semanas' },
    d: { one: 'hace %s día', other: 'hace %s días' },
    h: { one: 'hace %s hora', other: 'hace %s horas' },
    m: { one: 'hace %s minuto', other: 'hace %s minutos' },
    s: { one: 'hace %s segundo', other: 'hace %s segundos' },
  },
  futureLong: {
    y: { one: 'dentro de %s año', other: 'dentro de %s años' },
    M: { one: 'dentro de %s mes', other: 'dentro de %s meses' },
    w: { one: 'dentro de %s semana', other: 'dentro de %s semanas' },
    d: { one: 'dentro de %s día', other: 'dentro de %s días' },
    h: { one: 'dentro de %s hora', other: 'dentro de %s horas' },
    m: { one: 'dentro de %s minuto', other: 'dentro de %s minutos' },
    s: { one: 'dentro de %s segundo', other: 'dentro de %s segundos' },
  },
  abbr: {
    y: { one: '%s a', other: '%s a' },
    M: { one: '%s m', other: '%s m' },
    w: { one: '%s sem.', other: '%s sems.' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s año', other: '%s años' },
    M: { one: '%s mes', other: '%s meses' },
    w: { one: '%s semana', other: '%s semanas' },
    d: { one: '%s día', other: '%s días' },
    h: { one: '%s hora', other: '%s horas' },
    m: { one: '%s minuto', other: '%s minutos' },
    s: { one: '%s segundo', other: '%s segundos' },
  },
  justNow: 'ahora',
  yesterday: 'ayer',
  today: 'hoy',
  tomorrow: 'mañana',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D [de] MMMM [de] YYYY', end: 'D [de] MMMM [de] YYYY' },
    'yl-1': { start: 'D [de] MMMM', end: 'D [de] MMMM [de] YYYY' },
    ml: { start: 'D [de] MMMM', end: 'D [de] MMMM' },
    'ml-1': { start: 'D', end: 'D [de] MMMM [de] YYYY' },
    dl: { start: 'D', end: 'D [de] MMMM' },
    y: { start: 'D [de] MMM [de] YYYY', end: 'D [de] MMM [de] YYYY' },
    'y-1': { start: 'D [de] MMM', end: 'D [de] MMM [de] YYYY' },
    m: { start: 'D [de] MMM', end: 'D [de] MMM' },
    'm-1': { start: 'D', end: 'D [de] MMM [de] YYYY' },
    d: { start: 'D', end: 'D [de] MMM' },
    Y: { start: 'ddd, D [de] MMM [de] YYYY', end: 'ddd, D [de] MMM [de] YYYY' },
    'Y-1': { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM [de] YYYY' },
    M: { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM' },
    D: { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM' },
    yt: { start: 'D [de] MMM [de] YYYY, HH:mm', end: 'D [de] MMM [de] YYYY, HH:mm' },
    mt: { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm' },
    dt: { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm' },
    t: { start: 'H:mm', end: 'H:mm' },
    'yt+to': { start: 'D [de] MMM [de] YYYY, HH:mm', end: 'D [de] MMM [de] YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'H:mm', end: 'H:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'es-419';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}º`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a. m.' : 'a. m.';
    } else {
      return isLowerCase ? 'p. m.' : 'p. m.';
    }
  },
};
